import { ILocalStorageService } from "./ILocalStorageService";

export class LocalStorageService implements ILocalStorageService {
  set = (name: string, value: string) => {
    localStorage.setItem(name, value);
  };

  get = (name: string) => {
    return localStorage.getItem(name);
  };

  remove = (name: string) => {
    localStorage.removeItem(name);
  };

  hasKey = (key: string) => {
    return Object.keys(localStorage).includes(key);
  };
}

const instance = new LocalStorageService();

export default instance;
